import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export interface BarChartItem {
  label: string;
  value: number;
  color?: string;
}

interface HorizontalBarChartProps {
  title: string;
  items: BarChartItem[];
  emptyMessage?: string;
}

export const HorizontalBarChart = ({
  title,
  items,
  emptyMessage = 'No data for the selected period.',
}: HorizontalBarChartProps) => {
  const maxValue = Math.max(...items.map((i) => i.value), 1);
  const total = items.reduce((sum, i) => sum + i.value, 0);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {items.map((item, index) => {
            const widthPercent = maxValue > 0 ? (item.value / maxValue) * 100 : 0;
            const percentage = total > 0 ? Math.round((item.value / total) * 1000) / 10 : 0;

            return (
              <div key={`${item.label}-${index}`}>
                <div className="mb-1 flex items-center justify-between text-sm">
                  <span className="font-medium">{item.label}</span>
                  <div className="flex items-center gap-2">
                    <span className="text-foreground font-semibold">
                      {item.value.toLocaleString()}
                    </span>
                    <span className="text-muted-foreground text-xs">({percentage}%)</span>
                  </div>
                </div>
                <div className="bg-muted h-8 w-full overflow-hidden rounded-md">
                  <div
                    className={`h-full rounded-md transition-all duration-500 ${item.color ?? 'bg-primary'}`}
                    style={{ width: `${widthPercent}%` }}
                  />
                </div>
              </div>
            );
          })}
          {items.length === 0 && (
            <p className="text-muted-foreground py-6 text-center text-sm">{emptyMessage}</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
